import { API_PATH_INTERNAL } from '@/lib/constants'
import { getOfficeEnvironmentInfo } from '@/lib/helpers/officeHelpers'
import apiService from '@/lib/services/apiService'
import authService from '@/lib/services/authService'
import { CreateSessionMetadataRequest } from '@/types/requests/session-metadata'
import { SessionMetadataItem } from '@/types/responses/session-metadata'

class SessionService {
  private endpoint = `${API_PATH_INTERNAL}/session-metadata`

  async createSessionMetadata(): Promise<SessionMetadataItem> {
    const officeEnvironment = getOfficeEnvironmentInfo()
    const request: CreateSessionMetadataRequest = {
      previouslySelectedScope: authService.getPreviouslyUserSelectedScope(),
      previouslySelectedCompanyId:
        authService.getPreviouslyUserSelectedCompanyId(),
      ...(officeEnvironment && { officeEnvironment }),
    }

    const response = await apiService.post(this.endpoint, request)

    return response.data
  }
}

const sessionMetadataService = new SessionService()

export default sessionMetadataService
